import { render, staticRenderFns } from "./HomePolice.vue?vue&type=template&id=283effb6&scoped=true&"
import script from "./HomePolice.vue?vue&type=script&lang=js&"
export * from "./HomePolice.vue?vue&type=script&lang=js&"
import style0 from "./HomePolice.vue?vue&type=style&index=0&id=283effb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283effb6",
  null
  
)

export default component.exports